import React, { useState,useEffect } from 'react';
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { DealerAdmin } from "./DealerProvider";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import axios from 'axios';
import io from "socket.io-client";
import { FiArrowLeft } from 'react-icons/fi'; // or use any other arrow icon you like

const LoginPage = () => {
  const navigate = useNavigate(); // Call useNavigate as a function
  const { dealerDetails, updateDealerDetails } = DealerAdmin();
  const [FailureSignup,setFailureSignup]=useState(false);
    const [message,setfailuremessage]=useState("");
    
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [signup,setsignup]=useState(false);
  const [signupsucess,setsignupsuccess]=useState(false);
  const [formDataSignup, setFormDataSignup] = useState({
    username:"",
    name: "",
    email: "",
    contactNumber: "",
    password: "",
    id:"",
    companyName: "",
    Address: "",
    PostCode: "",
    city: "",
  });
  const [activeForm, setActiveForm] = useState('login'); // Default to "Login"
const [Failure,setFailure]=useState(false);

  const handleChangeSignup = (e) => {
    const { name, value } = e.target;
    setFormDataSignup({ ...formDataSignup, [name]: value });
  };

  const [customerId,setCustomerId]=useState('');
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handlePhoneChange = (value) => {
    setFormDataSignup({ ...formDataSignup, contactNumber: value });
  };

  const handleSignupSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setsignup(true);

    try {
        // Ensure `username` exists in formDataSignup
        if (!formDataSignup.username) {
            setfailuremessage("Username is required.");
            setFailureSignup(true);
            return;
        }

        const response = await axios.post('https://zoomautos.co.uk/api/Signup', formDataSignup, {
            headers: { "Content-Type": "application/json" }
        });

        // ✅ If signup is successful
        if (response.status === 201) {
          setCustomerId(response.data.Id);
          setsignupsuccess(true);
          setFailureSignup(false);
      
          setTimeout(() => {
              window.location.href = "/Logistics/Login"; // Redirect to login page
          }, 2000); // 2 seconds delay
      }
      
        else{
          setsignup(false)
        setfailuremessage(response.data.message || "Signup successful!");
        }
        // ✅ Set failure message even on success (for testing)
    } catch (error) {
      setsignup(false)
        
        // Handle different types of errors
        if (error.response) {
            // ❌ Server responded with an error (like 400)
            setfailuremessage(error.response.data.message || "Signup failed. Please try again.");
        } else if (error.request) {
            // ❌ Request was made but no response received
            setfailuremessage("No response from server. Check your connection.");
        } else {
            // ❌ Something else went wrong
            setfailuremessage("Unexpected error occurred.");
        }

        setFailureSignup(true);
    }


};



    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
  
  useEffect(() => {
    const storedUser = localStorage.getItem('DealerData');
  
    if (storedUser) {
      const user = JSON.parse(storedUser);
      updateDealerDetails(user); // Restore user details to context or state
    }
  }, []);
  
  useEffect(() => {
    // If user is logged in, redirect to the home page
    if (sessionStorage.getItem("authTokenDealer")) {
      navigate("/Companies/Home", { replace: true });
    }
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const response = await fetch('https://zoomautos.co.uk/api/Signup/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          identifier: formData.identifier,
          password: formData.password,
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        console.log('✅ User authenticated:', data);
  
        updateDealerDetails(data.user);
  
        // Store token if available (you mentioned earlier you might skip it)
        if (data.token) {
          sessionStorage.setItem('authTokenDealer', data.token);
        }
  
        localStorage.setItem('DealerData', JSON.stringify(data.user));
  
        // 👇 Initialize socket connection
        const socket = io("https://zoomautos.co.uk", {
          transports: ["websocket"], // avoid polling during dev
        });
        
        socket.on("connect", () => {
          console.log("✅ Connected to socket:", socket.id);
          socket.emit("register", data.user?.Id); // user ID goes here
        });
        
        socket.on("connect_error", (err) => {
          console.error("❌ Socket connection error:", err.message);
        });
  
        socket.on("connect_timeout", () => {
          console.error("⌛ Socket connection timed out");
        });
  
        // Reset UI state
        setFormData({ identifier: '', password: '' });
        setSuccess(true);
      } else {
        const errorMessage = data.message || 'Invalid username or password';
        console.error("🚫 Authentication failed:", errorMessage);
        setFailure(true);
      }
    } catch (error) {
      console.error("💥 Error during authentication:", error.message);
      setFailure(true);
      alert("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  
  
      useEffect(() => {
            if (Failure||FailureSignup) {
                setTimeout(() => {
                    setFailure(false);
                    setSuccess(false);
                    setFailureSignup(false)
                }, 2000);
      
            }
            if (success){
              setLoading(false);
              navigate('/Companies/Home');
            }
            if (signupsucess){
              setsignupsuccess(false);
              setActiveForm("login")
            }
        }, [success, Failure,signupsucess,FailureSignup]);
          

  return (
    <div className="login-page">
     <button onClick={() => navigate(-1)} className="back-button">
      <FiArrowLeft size={20}/>
    </button>
      <div className="login-container">
        <div className="logo-container">
          <img src="/Logo4.png" alt="Logo" />
        </div>
        <div className="button-bar">
    <button
      className={activeForm === 'login' ? 'active' : ''}
      onClick={() => setActiveForm('login')}
    >
      Login
    </button>
    <button
      className={activeForm === 'signup' ? 'active' : ''}
      onClick={() => setActiveForm('signup')}
    >
      Sign Up
    </button>
  </div>
  {activeForm === 'login' && (
        <div className="login-form">
          <h2 className="headline">Welcome to Zoom Autos</h2>

          <form onSubmit={handleSubmit}>
          
          <input
  type="text"
  name="identifier"  // Can be email or username
  placeholder="Username or Email"
  value={formData.identifier}
  onChange={handleChange}
/>

            
            <input
              type="password"
              name="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={handleChange} // Add onChange handler
            />
             <div className="login-extra-text">
              
        <a  onClick={() => 
          
          navigate('/Logistics/Login/Forget-password')
          }>
          Forget Password?
        </a>
      </div>
            <button type="submit">Login</button>
          </form>
          
        </div>
  )}

{activeForm === 'signup' && (
  <>
   <h2 className="headline">Welcome to Zoom Autos</h2>
   <h3>Get Registered with Us</h3>
   <div className="signups-form">
   <form onSubmit={handleSignupSubmit}>
   <label>Username:</label>
         <input
           type="text"
           name="username"
           value={formDataSignup.username}
           onChange={handleChangeSignup}
           placeholder="Enter your Username for example zoom1723"
           required
           
         />
         <label>Name:</label>
         <input
           type="text"
           name="name"
           value={formDataSignup.name}
           onChange={handleChangeSignup}
           placeholder="Enter your full name"
           required
           
         />
       
       
         <label>Email Address:</label>
         <input
           type="email"
           name="email"
           value={formDataSignup.email}
           onChange={handleChangeSignup}
           placeholder="Enter your email"
           required
           
         />
       
       
         <label>Contact Number:</label>
         <PhoneInput
           country={"gb"}
           value={formDataSignup.contactNumber}
           onChange={handlePhoneChange}
           inputStyle={{border:' 2px solid #01103b'}}
           required
         />
       
   
         
         <label>Password:</label>
         <input
           type="password"
           name="password"
           value={formDataSignup.password}
           onChange={handleChangeSignup}
           placeholder="Enter your password"
           required
           
         />
       
  
         <label>Confirm Password:</label>
         <input
           type="password"
           name="confirmPassword"
           value={formDataSignup.confirmPassword}
           onChange={handleChangeSignup}
           placeholder="Confirm your password"
           required
           
         />
       
   
       
         <label>Company Name:</label>
         <input
           type="text"
           name="companyName"
           value={formDataSignup.companyName}
           onChange={handleChangeSignup}
           placeholder="Enter your company name"
           required
           
         />
       
         <label>Address:</label>
         <input
           type="text"
           name="Address"
           value={formDataSignup.Address}
           onChange={handleChangeSignup}
           placeholder="Enter your address"
           required
           
         />
       
   
       
         <label>Post Code:</label>
         <input
           type="text"
           name="PostCode"
           value={formDataSignup.PostCode}
           onChange={handleChangeSignup}
           placeholder="Enter your post code"
           required
           
         />
       
         <label>City:</label>
         <input
           type="text"
           name="city"
           value={formDataSignup.city}
           onChange={handleChangeSignup}
           placeholder="Enter your city"
           required
           
         />
         
         <button
          type="submit"
          

        >
          Signup
        </button>
        
        </form>
         </div>
       </>
       
)}
      </div>

      {loading && (
        <div className='overlayStyle'>
          <div className='loadingStyle'  >Signing in...</div>
        </div>
      )}

{Failure && (
        <div className='overlayStyle'>
          <div className='FailureStyle'  >Login Failed</div>
        </div>
      )}
      {FailureSignup && (
        <div className='overlayStyle'>
          <div className='FailureStyle'  >
            <p>Registration Failed </p>
          <p>{message}</p>
          </div>
        </div>
      )}

      {/* Success Overlay */}
      {success && (
        <div className='overlayStyle'>
          <div className='successStyle' >Success</div>
        </div>
      )}
      {signup && (
        <div className='overlayStyle'>
          <div className='loadingStyle'  >Registering...</div>
        </div>
      )}

      {/* Success Overlay */}
      {signupsucess && (
        <div className='overlayStyle'>
          <div className='successStyle' >Thanks for Registering With US</div>
        </div>
      )}      
    </div>

  );
};

export default LoginPage;
